import pkg from "../package.json";

// The version this bundle was built with — baked in at build time.
// Compared against the live /version.json (see hooks/useVersionCheck.js)
// to detect when a newer build has been deployed behind CloudFront.
export const APP_VERSION = pkg.version;
